import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Deliveries from './views/Deliveries.vue'
import DeliveryArchive from './views/DeliveryArchive.vue'
import Delivered from './views/Delivered.vue'
import Complaints from './views/Complaints.vue'
import HomeOrders from './views/HomeOrders.vue'
import localforage from 'localforage'
import store from './store'
import DeliveryPlanning from "./views/DeliveryPlanning";
import Scanner from "./views/Scanner";

Vue.use(Router)

export const router = new Router({
    mode: 'history',
    base: process.env.VUE_APP_PUBLIC_PATH,
    linkExactActiveClass: 'is-active',
    routes: [
        {   path: '/index.html',
            component: Login,
            alias: '/'
        },
        {
            path: '/',
            name: 'login',
            component: Login
        },
        {
            path: '/logout',
            name: 'logout',
            component: Login
        },
        {
            path: '/deliveries',
            name: 'deliveries',
            component: Deliveries,
            meta: {
                requiresAuth: true,
                title: 'Twoje dostawy'
            }
        },
        {
            path: '/delivered',
            name: 'delivered',
            component: Delivered,
            meta: {
                requiresAuth: true,
                title: 'Dostarczone dostawy'
            }
        },
        {
            path: '/deliveries-planning',
            name: 'deliveries-planning',
            component: DeliveryPlanning,
            meta: {
                requiresAuth: true,
                title: 'Planowanie dostaw'
            }
        },
        {
            path: '/deliveries-archive',
            name: 'deliveries-archive',
            component: DeliveryArchive,
            meta: {
                requiresAuth: true,
                title: 'Archiwalne dostawy'
            }
        },
        {
            path: '/complaints',
            name: 'complaints',
            component: Complaints,
            meta: {
                requiresAuth: true,
                title: 'Reklamacje'
            }
        },
        {
            path: '/home-orders',
            name: 'home-orders',
            component: HomeOrders,
            meta: {
                requiresAuth: true,
                title: 'Home Orders'
            }
        },
        {
            path: '/scanner',
            name: 'scanner',
            component: Scanner,
            meta: {
                requiresAuth: true,
                title: 'Skaner kodów'
            }
        }
    ],
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
})

// check protected routes
router.beforeEach((to, from, next) => {
    // logout
    if(to.name === 'logout'){
        localforage.removeItem('authUser').then(() => {
            // remove user from backend

            next({name:'login'})
        })
    }
    // redirect logged user to deliveries
    if(to.path === '/'){
        localforage.getItem('authUser').then((authUser) => {
            if(authUser !== 'undefined' && authUser !== null){
                next({name:'deliveries'})
            } else {
                next()
            }
        })
    }
    // check auth routes
    if(to.meta.requiresAuth){
        store.dispatch('checkTokenValidity').then(() => {
            next()
        }).catch(error => {
            next({name:'logout'})
            store.dispatch('addNotification', {
                type: 'warning',
                content: error
            })
        })
    } else {
        next()
    }
})
